import { textAnimations } from './utils/text-animations'

export default function (form = false) {
  // -------------------------------------
  // Texts animations
  // -------------------------------------
  textAnimations()

  // -------------------------------------
  // Cloudflare Turnstile Captcha
  // -------------------------------------
  /* global turnstile */
  if (turnstile && document.querySelector('.captcha-render')) {
    turnstile.render('.captcha-render', {
      sitekey: '0x4AAAAAABiEANAQ0hbRWkye',
      theme: 'light'
    })
  }

  if (form === true) {
    setTimeout(() => {
      if (document.querySelectorAll('.wpcf7 > form').length > 0) {
        document.querySelectorAll('.wpcf7 > form').forEach((e) => {
          /* global wpcf7 */
          return wpcf7.init(e)
        })
      }
    }, 1000)
  }
}
